import { ArrowDown01, ArrowDownAZ, CalendarDays, CopyX, FileDigit, Trash2, Type } from "lucide-react";

export const WORKFLOW_VARIABLE_LABELS = {
  ACTIVE_MEMBER: "Active Member",
  CUSTOM_FIELD: "Custom Field",
  DROPDOWN: "dropdown",
  VARIBALE_PROPERTIES: "Variable Properties",
  CHIP_PROPERTIES: "Chip Properties",
  VARIABLE_NAME_DUPLICATE_ERROR: "Variable name is duplicate",
  VARIABLE_NAME_REQUIRED_ERROR: "Variable name is Required",
  REQUIRED: "Required Field",
  REUSABLE_CHIP: "Reusable Chip",
  PLACEHOLDER: "Placeholder",
  DEFAULT_ANSWER: "Default Answer",
  MAX_TEXT_LENGTH: "Maximum Text Length",
  MIN_TEXT_LENGTH: "Minimum Text Length",
  MAX_VALUE: "Maximum Value",
  MIN_VALUE: "Minimum Value",
  ENTER_PLACEHOLDER: "Enter Placeholder",
  ENTER_DEFAULT_ANSWER: "Enter Default Answer",
  ENTER_MAX_LENGTH: "Enter Maximum Text Length",
  ENTER_MIN_LENGTH: "Enter Minimum Text Length",
  DEFAULT_SELECTION: "Default Selection",
  MULTI_SELECT: "Multi-Select",
  PREFETCHED_FIELDS: "Preset Chips",
  ADMIN_FIELD: "admin field",
  EXISTING_FIELDS: "Chips",
  CUSTOM_CHIPS: "Custom Chips",
  CHIP: "Chip",
  CHIPS: "Chips",
  ADD_FIELD: "+ New",
  ADD_PRESET_FIELD: "+ Presets",
  ADD_PRESET: "Add Preset",
  ADD_ADMIN_PRESET: "Add Global Chip",
  ADD_CUSTOM_CHIP: "Add Workflow Chip",
  ADD_SMART_CHIP: "Add Workflow Chip",
  ADD_CHIP: "Add Chip",
  ADMIN_PRESET: "Global Chip",
  CUSTOM_CHIP: "Custom Chip",
  WORKFLOW_CHIP: "Workflow Chip",
  SMART_CHIP: "Smart Chip",
  NAME: "Name",
  FIELD_TYPE: "Field Type",
  CANCEL: "Cancel",
  SAVE: "Save",
  NO_CUSTOM_VARIABLES: "No Chips Added",
  NO_CHIP_DESCRIPTION_LABEL: "No Description Available",
  PRESET_VARIABLES: "Preset Variables",
  ADMIN: "Admin",
  IS_ADMIN_FIELD: "admin",
  ADD_OPTION: "Add Option",
  OPTIONS: "Options",
  SMART_CHIP: "Smart Chip",
  DELETE_ALL: "Delete All",
  DELETE_OPTION: "Delete Option",
  DELETE_CHIP: "Delete Chip",
  REQUIRED_OPTIONS: "Add atleast 1 option to proceed",
  EMPTY_OPTION: "Option cannot be empty",
  CHIP_TYPE: "Chip Type",
  NEW: "New",
  DATE_FORMAT: "Date Format",
  DATE_SEPARATOR: "Date Separator",
  PAST_DATES: "Past Dates",
  FUTURE_DATES: "Future Dates",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  START_DATE_GREATER_THAN_END_DATE: "Start Date is greater than End Date",
  DATE_OUT_OF_RANGE: "Default Date is out of range",
  DEFAULT_DATE_LESSER_THAN_START_DATE: "Default Date is lesser than Start Date",
  DEFAULT_DATE_GREATER_THAN_END_DATE: "Default Date is greater than End Date",
  DECIMAL: "Decimal",
  POSITIVE_NUMBER: "Only Positive Number",
  MIN_MAX_VALUE: "Minimum value is greater than maximum value",
  DEFAULT_VALUE_LESS_THAN_MIN_VALUE: "Default value is less than minimum value",
  DEFAULT_VALUE_GREATER_THAN_MAX_VALUE: "Default value is greater than maximum value",
  MIN_VALUE_LESS_THAN_ZERO: "Minimum value is less than zero",
  DEFAULT_VALUE_LESS_THAN_ZERO: "Default value is less than zero",
  MAX_VALUE_LESS_THAN_ZERO: "Maximum value is less than zero",
  PLEASE_FILL_VALUES: "Please fill values",
  SMART_CHIP_HINT: "For use in forms only.",
  SHOW_IF: "Show If",
  EDIT_SHOW_IF_CONDITION: "Edit condition",
  SHOW_IF_MODAL_TITLE: "Show If Condition",
  REUSABLE_CHIP_HINT: "For use in text description box (tasks & tickets).",
  NAME_REQUIRED: "Name is required",
  FIELD_TYPE_REQUIRED: "Field Type is required",
  CHIP_TYPE_REQUIRED: "Chip Type is required",
  FORM_REQUIRED_HINT: "Applicable only for forms.",
  AUTOMATICALLY_SET_VALUE: "Automatically Set Value",
  EXPRESSION_EDITOR: "Expression Editor",
  EDIT_EXPRESSION: "Edit Expression",
  UNSAVED_CHANGES_WARNING: "You have unsaved changes. Are you sure you want to close?",
  DELETE_CHIP_WARNING: "Chip in use for another Form",
  DELETE_CHIP_ALREADY_IN_USE: "This chip is already in use in a form and cannot be deleted.",
  MULTI_DIMENSION: "Multi-Dimension",
  MULTI_DIMENSION_EDIT: "Edit",
  MULTI_DIMENSION_IRREVERSIBLE: "This cannot be reverted.",
  MULTI_DIMENSION_PAGE_TITLE: "Multi-Dimension Chip Properties",
  MULTI_DIMENSION_MODAL_TITLE: "Multi-Dimension Configuration",
  OPTIONS_COLUMN_LABEL: "Options",
  ADD_ROW_LABEL: "Add Row",
  ADD_COLUMN_LABEL: "Add Column",
  MULTI_DIMENSION_COLUMN_NAME: "Name",
  MULTI_DIMENSION_COLUMN_TYPE: "Type",
  MULTI_DIMENSION_COLUMN_NAME_MAX: 30,
  MULTI_DIMENSION_TYPE_TEXT: "Text",
  MULTI_DIMENSION_TYPE_NUMBER: "Number",
  MULTI_DIMENSION_TYPE_DATE: "Date",
  MULTI_DIMENSION_DELETE_COLUMN: "Delete",
  MULTI_DIMENSION_UPDATE_COLUMN: "Update",
  MULTI_DIMENSION_MAX_COLUMNS_REACHED: "Maximum 10 columns (including Options).",
  MULTI_DIMENSION_MIN_COLUMNS: "At least one dimension column is required.",
  MULTI_DIMENSION_FILTER_TITLE: "Filter",
  MULTI_DIMENSION_FILTER_APPLY: "Filter",
  MULTI_DIMENSION_FILTER_CLEAR: "Clear",
  MULTI_DIMENSION_FILTER_LOGIC_AND: "And",
  MULTI_DIMENSION_FILTER_LOGIC_OR: "Or",
  MULTI_DIMENSION_FILTER_LABEL_ROW: "Filter",
  NO_DUPLICATE_OPTIONS: "No duplicate options",
  MULTI_DIMENSION_ADD_ROW_CLEARS_FILTERS_TITLE: "Add Row Clears Filters",
  MULTI_DIMENSION_ADD_ROW_CLEARS_FILTERS_MESSAGE: "Adding a new row will clear all existing filters. Are you sure you want to proceed?",
  MULTI_DIMENSION_ADD_ROW_CLEARS_FILTERS_CANCEL: "Cancel",
  MULTI_DIMENSION_ADD_ROW_CLEARS_FILTERS_CONFIRM: "Confirm",
};

/** Synthetic id for the Options column filter (never overlaps API dimension ids). */
export const MULTI_DIMENSION_OPTIONS_COLUMN_FILTER_ID = "__options_label__";

/** Options column + at most this many dimension columns = 10 columns total. */
export const MULTI_DIMENSION_MAX_DIMENSION_COLUMNS = 9;

/** Minimum dimension columns (cannot delete the last one). */
export const MULTI_DIMENSION_MIN_DIMENSION_COLUMNS = 1;

export const MULTI_DIMENSION_TYPE_VALUES = ["text", "number", "date"];

export const MULTI_DIMENSION_DEFAULT_TYPE = "text";

export const MULTI_DIMENSION_TYPE_OPTIONS = [
  { label: WORKFLOW_VARIABLE_LABELS.MULTI_DIMENSION_TYPE_TEXT, value: "text" },
  { label: WORKFLOW_VARIABLE_LABELS.MULTI_DIMENSION_TYPE_NUMBER, value: "number" },
  { label: WORKFLOW_VARIABLE_LABELS.MULTI_DIMENSION_TYPE_DATE, value: "date" },
];

/**
 * @param {string} [t]
 * @returns {"text"|"number"|"date"}
 */
export const normalizeMultiDimensionType = (t) => {
  const v = (t || MULTI_DIMENSION_DEFAULT_TYPE).toLowerCase();
  return MULTI_DIMENSION_TYPE_VALUES.includes(v) ? v : MULTI_DIMENSION_DEFAULT_TYPE;
};

export const VARIABLE_ICONS = {
  number_dropdown: <ArrowDown01 className='lucid-icon-common' />,
  text: <Type className='lucid-icon-common' />,
  dropdown: <ArrowDownAZ className='lucid-icon-common' />,
  delete_all: <CopyX className='lucid-icon-common cursor-pointer grey' />,
  delete: <Trash2 className='lucid-icon-common cursor-pointer grey' />,
  date: <CalendarDays className='lucid-icon-common' />,
  number: <FileDigit className='lucid-icon-common' />,
};

/** Icon for the Options column header (matches dropdown number vs text chip mode). */
export const getMultiDimensionOptionsColumnIcon = (numberOnly) =>
  numberOnly ? VARIABLE_ICONS.number_dropdown : VARIABLE_ICONS.text;

export const CHIP_TYPE_DATA = [
  { label: WORKFLOW_VARIABLE_LABELS.REUSABLE_CHIP, value: WORKFLOW_VARIABLE_LABELS.REUSABLE_CHIP.toLowerCase() },
  { label: WORKFLOW_VARIABLE_LABELS.SMART_CHIP, value: WORKFLOW_VARIABLE_LABELS.SMART_CHIP.toLowerCase() },
];

export const getDateFormatOptions = (dateSeparator) => {
  return [
    { label: `dd${dateSeparator}MM${dateSeparator}yyyy`, value: 1 },
    { label: `MM${dateSeparator}dd${dateSeparator}yyyy`, value: 2 },
    { label: `yyyy${dateSeparator}MM${dateSeparator}dd`, value: 3 },
    { label: `dd MMM yy`, value: 4 },
  ];
};

export const newVariableTypes = [
  {
    id: 1,
    variableName: "Dropdown",
    variableType: "dropdown",
  },
  {
    id: 2,
    variableName: "Textbox",
    variableType: "text",
  },
  {
    id: 3,
    variableName: "Date",
    variableType: "date",
  },
  {
    id: 4,
    variableName: "Number",
    variableType: "number",
  },
];
